'use strict';
import classNames from 'classnames';
import get from 'lodash/get';
import * as T from 'prop-types';
import React from 'react';
import {I18nComponent} from '../../../core-utilities/react-i18n';
import {DropdownList} from '../../DropdownList';


export function BaseDropdownListFieldView(props) {
  return (
    <div className={classNames("FormField", props.className)}>
      <label
        htmlFor={props.uid}
        className={classNames("FormField__title", {
          FormField__title_required: props.isEditing && props.isRequired,
        })}
      >
        {props.label}
      </label>
      {props.isEditing ? (
        <DropdownList
          className={classNames('DropdownListField__input', {
            DropdownListField__input_valid: !props.errorValue,
            DropdownListField__input_error: props.errorValue,
            FormField__input_saving: props.isSaving,
          })}
          baseClassName={props.baseClassName}
          controlClassName={props.controlClassName}
          placeholderClassName={props.placeholderClassName}
          menuClassName={props.menuClassName}
          arrowClassName={props.arrowClassName}
          optionConfig={props.optionConfig}
          options={props.options}
          disabled={props.disabled || props.isSaving}
          value={props.value}
          selectNull={props.selectNull}
          placeholder={props.nullLabel}
          eagerFetch={props.eagerFetch}
          itemHeight={props.itemHeight}
          maxHeight={props.maxHeight}
          minToFilter={props.minToFilter}
          mode={props.mode}
          hasMore={props.hasMore}
          checkIsSelected={props.checkIsSelected}
          getKey={props.getKey}

          onChange={props.onChange}
          onFocus={props.onFocus}
          onFilterChange={props.onFilterChange}
          onLoadMore={props.onLoadMore}
        />
      ) : (
        <div className="FormField__value">
          {get(props.value, 'value') ? props.value.label : props.nullLabel}
        </div>
      )}
      {renderError(props)}
    </div>
  );
}

function renderError(props) {
  if (props.isEditing && props.errorValue) {
    return (
      <div className="FormField__input_error">
        {props.errorValue}
      </div>
    );
  } else {
    return null;
  }
}

BaseDropdownListFieldView.propTypes = {
  className: T.string,
  label: T.string.isRequired,
  value: T.any,
  errorValue: T.string,
  onChange: T.func.isRequired,

  disabled: T.bool,
  isEditing: T.bool,
  isSaving: T.bool,
  isRequired: T.bool,
};

BaseDropdownListFieldView.defaultProps = {
  className: '',
};

export const DropdownListFieldView = I18nComponent(BaseDropdownListFieldView, [
  {prop: 'nullLabel', dynamic: getNullLabel},
  {prop: 'errorValue', dynamic: getErrorMsg},
]);

function getNullLabel(props) {
  return props.nullLabel;
}

function getErrorMsg(props) {
  return props.error;
}



// WEBPACK FOOTER //
// ./src/js/components/forms/DropdownListField/DropdownListFieldView.js